(function () {
  if (window.__croCartPopup) return;
  window.__croCartPopup = true;

  /* ---- timing (change these numbers to adjust) ---- */
  var AUTO_CLOSE_MS = 6000; /* popup auto-hides after this on desktop + mobile */
  var MIN_RESUME_MS = 2000; /* after hover/touch ends, never close sooner than this */

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var isCartPage = document.body.classList.contains('template-cart');

    /* Only remove the native title tooltip on the drawer checkout button.
       The theme's vertical hover animation is intentionally kept. */
    function stripCheckoutTitle() {
      document.querySelectorAll('#site-cart-sidebar #CheckOut, #site-cart-sidebar #ViewCart').forEach(function (b) {
        if (b.hasAttribute('title')) b.removeAttribute('title');
      });
    }
    stripCheckoutTitle();
    var subtotalEl = document.getElementById('AjaxCartSubtotal');
    if (subtotalEl && window.MutationObserver) {
      new MutationObserver(function () { stripCheckoutTitle(); }).observe(subtotalEl, { childList: true, subtree: true });
    }
    document.addEventListener('krown:cart:add', stripCheckoutTitle);
    document.addEventListener('krown:cart:update', stripCheckoutTitle);

    var popup = document.getElementById('cro-cart-popup');
    if (!popup) return;

    var panel = popup.querySelector('.cro-cart-popup__panel');
    var imgWrap = popup.querySelector('[data-cro-popup-image]');
    var imgEl = imgWrap ? imgWrap.querySelector('img') : null;
    var titleEl = popup.querySelector('[data-cro-popup-title]');

    /* ---- auto-close with pause/resume that works on mouse AND touch ---- */
    var autoCloseTimer = null;
    var deadline = 0;        /* timestamp when the popup is scheduled to close */
    var paused = false;

    function clearTimer() { if (autoCloseTimer) { clearTimeout(autoCloseTimer); autoCloseTimer = null; } }

    /* schedule close after `ms` from now */
    function schedule(ms) {
      clearTimer();
      deadline = Date.now() + ms;
      autoCloseTimer = setTimeout(closePopup, ms);
    }

    function pauseAutoClose() {
      if (paused || !popup.classList.contains('cro-cart-popup--open')) return;
      paused = true;
      clearTimer();
    }

    function resumeAutoClose() {
      if (!paused || !popup.classList.contains('cro-cart-popup--open')) { paused = false; return; }
      paused = false;
      var remaining = deadline - Date.now();
      if (remaining < MIN_RESUME_MS) remaining = MIN_RESUME_MS;
      schedule(remaining);
    }

    function openPopup() {
      paused = false;
      popup.classList.add('cro-cart-popup--open');
      popup.setAttribute('aria-hidden', 'false');
      schedule(AUTO_CLOSE_MS);
    }
    function closePopup() {
      paused = false;
      clearTimer();
      popup.classList.remove('cro-cart-popup--open');
      popup.setAttribute('aria-hidden', 'true');
    }

    popup.querySelectorAll('[data-cro-popup-close]').forEach(function (el) {
      el.addEventListener('click', closePopup);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('cro-cart-popup--open')) closePopup();
    });

    /* Pause while the pointer (mouse or finger) is over/interacting with the panel,
       resume (counting the remaining time, min MIN_RESUME_MS) when it leaves. */
    if (panel && window.PointerEvent) {
      panel.addEventListener('pointerenter', pauseAutoClose);
      panel.addEventListener('pointerdown', pauseAutoClose);
      panel.addEventListener('pointerleave', resumeAutoClose);
      panel.addEventListener('pointerup', resumeAutoClose);
      panel.addEventListener('pointercancel', resumeAutoClose);
    } else if (panel) {
      /* Fallback for old browsers without Pointer Events */
      panel.addEventListener('mouseenter', pauseAutoClose);
      panel.addEventListener('mouseleave', resumeAutoClose);
      panel.addEventListener('touchstart', pauseAutoClose, { passive: true });
      panel.addEventListener('touchend', resumeAutoClose);
      panel.addEventListener('touchcancel', resumeAutoClose);
    }

    /* ---- surgical drawer suppression: only the add-triggered auto-open ---- */
    var suppressUntil = 0;
    var drawer = null;

    function patchDrawer() {
      drawer = document.getElementById('site-cart-sidebar');
      if (!drawer || drawer.__croPatched || typeof drawer.show !== 'function') return;
      drawer.__croPatched = true;
      var origShow = drawer.show.bind(drawer);
      drawer.show = function () {
        if (Date.now() < suppressUntil) { suppressUntil = 0; return; }
        return origShow.apply(drawer, arguments);
      };
    }
    patchDrawer();

    if (!isCartPage) {
      document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form || !form.closest) return;
        var pf = form.closest('product-form');
        if (pf && pf.hasAttribute('data-ajax-cart')) {
          patchDrawer();
          suppressUntil = Date.now() + 8000;
        }
      }, true);
    }
    document.addEventListener('krown:cart:error', function () { suppressUntil = 0; });

    /* ---- show popup on successful add (PDP + collection cards, mobile + desktop) ---- */
    document.addEventListener('krown:cart:add', function (e) {
      if (isCartPage) return;
      var variantId = (e && e.detail && e.detail.variantId) ? e.detail.variantId : null;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
      fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var item = null, i;
          if (variantId && cart.items) {
            for (i = cart.items.length - 1; i >= 0; i--) {
              if (String(cart.items[i].variant_id) === String(variantId)) { item = cart.items[i]; break; }
            }
          }
          if (!item && cart.items && cart.items.length) item = cart.items[cart.items.length - 1];
          if (item && imgEl) {
            var img = item.image || (item.featured_image && item.featured_image.url) || '';
            if (img) {
              if (img.indexOf('//') === 0) img = 'https:' + img;
              imgEl.src = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=240';
              imgEl.alt = item.product_title || item.title || '';
              if (imgWrap) imgWrap.style.display = '';
            } else if (imgWrap) {
              imgWrap.style.display = 'none';
            }
          }
          if (item && titleEl) titleEl.textContent = item.product_title || item.title || '';
          suppressUntil = 0;
          openPopup();
        })
        .catch(function () {
          suppressUntil = 0;
          openPopup();
        });
    });
  });
})();
